// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__zel0a","header":"Faq_header__u4ljr","mg":"Faq_mg__29M2_","spinAround":"Faq_spinAround__T4j0x"};